<template>
  <div>
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>My Cloud Booth</BreadcrumbItem>
          <BreadcrumbItem to="/exhibitionEn/index/certificate/allcertificate">Certifications</BreadcrumbItem>
          <BreadcrumbItem>Edit Certifications</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.nameEn}}</div>
        <p class="header-tool-text">Notice: cerficate will be displayed on the home page of the My Cloud Booth. <span class="preview" @click="$router.push('/exhibitionEn/index/template')">Click to take a preview</span></p>
      </div>
    </div>
    <div class="my-item">
      <div class="addcertificate">
        <div class="f-tar" style="padding: 20px;">
          <Button @click="$router.push('/exhibitionEn/index/certificate/allCertificate')">Back</Button>
        </div>
        <div class="addcertificate-box">
          <div class="my-modal">
            <div class="my-modal-content">
              <Form ref="formInline" :label-width="150" :model="formInline" :rules="ruleInline">
                <FormItem label="Upload certificate：" :required="true">
                  <div
                    class="my-upload-list"
                    v-for="(item, index) in uploadList"
                    :key="'upload' + index"
                    style="width: 100px;height: 100px;line-height:100px;margin-bottom:0;"
                  >
                    <template v-if="item.status === 'finished'">
                      <img :src="item.url" style="width:100%;height:100%;" />
                      <div class="my-upload-list-cover">
                        <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                        <Icon
                          type="ios-trash-outline"
                          @click.native.stop.prevent="handleRemoveByArr(item)"
                        ></Icon>
                      </div>
                    </template>
                    <template v-else>
                      <Spin v-if="item.showProgress" style="width: 100px;height: 100px;">
                        <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                      </Spin>
                    </template>
                  </div>
                  <Upload
                    ref="upload"
                    :show-upload-list="false"
                    :default-file-list="defaultList"
                    :on-success="handleSuccess"
                    :format="['jpg','jpeg','png']"
                    :max-size="2048"
                    :headers="formHeaders"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize"
                    :before-upload="handleBeforeUpload"
                    type="drag"
                    :action="uploadUrl"
                    multiple
                    style="display: inline-block;width:100px;"
                    v-show="uploadList && uploadList.length < 1"
                  >
                    <div style="width: 100px;height:100px;padding-top:15px;color:rgb(133, 133, 133);">
                      <div style="font-size:25px;">
                        +
                        <p style="font-size:14px;">Upload picture</p>
                      </div>
                    </div>
                    <!-- 蒙版 -->
                    <div
                      style="position:absolute;opacity:0;width:80px;height:80px;left:0;top:0;"
                      @click.stop="selectType"
                    ></div>
                  </Upload>
                  <p style="font-size:12px;">(Requirements: .jpg/png within 2M, suggested size is 500*700px)</p>
                  <p style="font-size:12px;">We recommand to upload general agency certification, invention patent, honor certificates, etc</p>
                </FormItem>
                <FormItem label="Certificate name：" prop="name">
                  <Select v-model="formInline.name" filterable allow-create @on-create="handleCreate">
                    <Option v-for="item in certificateType" :value="item.nameEn" :key="item.nameEn">{{ item.nameEn }}</Option>
                  </Select>
                  <!-- <Input v-model="formInline.name" placeholder="请输入资质证书名称" /> -->
                </FormItem>
                <FormItem label="Serial number：" prop="number" :required="true">
                  <Input v-model="formInline.number" placeholder="Please enter the serial number" />
                </FormItem>
                <FormItem label="Issuing authority：" prop="authority" :required="true">
                  <Input v-model="formInline.authority" placeholder="Please enter the issuing authority" />
                </FormItem>
                <FormItem label="Time of issuance：" prop="time">
                  <DatePicker
                    v-model="formInline.time"
                    type="date"
                    placeholder="Please select the time when the qualification certificate is issued"
                    style="width: 100%"
                  ></DatePicker>
                </FormItem>
                <FormItem>
                  <Checkbox size="large" v-model="formInline.isShow">
                    <span style="display: inline-block;width: 10px;"></span>Turn on the display
                  </Checkbox>
                </FormItem>
                <FormItem label="Display order：">
                  <InputNumber :min="0" v-model="formInline.showIndex"></InputNumber>
                  <br />
                </FormItem>
                <FormItem label="介绍：" v-if="false">
                  <RadioGroup v-model="formInline.activityType">
                    <Radio size="large" label="0">文字说明</Radio>
                    <Radio size="large" label="1">图片展示</Radio>
                  </RadioGroup>
                  <div style="margin-top: 20px;">
                    <div v-if="formInline.activityType == 0">
                      <FormItem prop="Introduction">
                        <Input
                          type="textarea"
                          v-model="formInline.Introduction"
                          :rows="8"
                          placeholder="请输入文字说明"
                        />
                      </FormItem>
                    </div>
                    <div v-if="formInline.activityType == 1">
                      <div
                        class="my-upload-list"
                        v-for="(item, index) in uploadList2"
                        :key="'upload' + index"
                        style="width: 80px;height: 80px;line-height:80px"
                      >
                        <template v-if="item.status === 'finished'">
                          <img :src="item.url" />
                          <div class="my-upload-list-cover">
                            <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                            <Icon
                              type="ios-trash-outline"
                              @click.native.stop.prevent="handleRemoveByArr2(item)"
                            ></Icon>
                          </div>
                        </template>
                        <template v-else>
                          <Spin v-if="item.showProgress" style="width: 80px;height: 80px;">
                            <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                          </Spin>
                        </template>
                      </div>
                      <Upload
                        ref="upload2"
                        :show-upload-list="false"
                        :default-file-list="defaultList2"
                        :on-success="handleSuccess2"
                        :format="['jpg','jpeg','png']"
                        :max-size="2048"
                        :headers="formHeaders"
                        :on-format-error="handleFormatError"
                        :on-exceeded-size="handleMaxSize"
                        :before-upload="handleBeforeUpload2"
                        type="drag"
                        :action="uploadUrl"
                        multiple
                        style="display: inline-block;width:80px;"
                        v-show="uploadList2 && uploadList2.length < limitNum"
                      >
                        <div style="width: 80px;height:80px;padding-top: 7px;">
                          <div>
                            +
                            <p>上传</p>
                          </div>
                        </div>
                        <!-- 蒙版 -->
                        <div
                          style="position:absolute;opacity:0;width:80px;height:80px;left:0;top:0;"
                          @click.stop="selectType2"
                        ></div>
                      </Upload>
                      <p style="font-size: 12px;">(图片要求：2M以下jpg或png的图片，宽度为：750px)</p>
                      <iModal title="View Image" v-model="visible">
                        <img
                          :src="'https://o5wwk8baw.qnssl.com/' + imgName + '/large'"
                          v-if="visible"
                          style="width: 100%"
                        />
                      </iModal>
                    </div>
                  </div>
                </FormItem>
                <FormItem label="Introduction：" :required="true">
                  <div class="no-padding">
                    <customComponentCommon v-model="Introduction" :type="commonType" @change="changModal"></customComponentCommon>
                  </div>
                </FormItem>
                <FormItem>
                  <Button
                    type="primary"
                    size="large"
                    :loading="loading"
                    @click="handleSubmit('formInline',0)"
                    style="width:140px;height:35px;font-size:14px;"
                  >Save</Button>
                  <Button
                    type="primary"
                    @click="handleSubmit('formInline',1)"
                    style="width:140px;height:35px;font-size:14px;margin-left:20px;"
                  >Save and Preview</Button>
                </FormItem>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <iModal title="图片查看" cancel-text v-model="visible" :z-index="10002">
      <div style="text-align: center;">
        <img :src="imgName" v-if="visible" style="max-width: 100%" />
      </div>
    </iModal>
    <!-- 选择文件上传方式 -->
    <imgUpload
      @upload:local="uploadLocal"
      @upload:material="uploadMaterial"
      :maxCount="1"
      v-model="uploadChooseShowed"
    />
    <uploadChoose
      @upload:local="uploadLocal2"
      @upload:material="uploadMaterial2"
      fileType="img"
      :maxCount="10"
      v-model="uploadChooseShowed2"
    />
  </div>
</template>

<script>
let moment = require("moment");
import { mapActions, mapGetters } from "vuex";
import uploadChoose from "@components/En/uploadChoose/uploadChoose";
import customComponentCommon from "@components/En/custom-component/custom-component-common.vue";
import imgUpload from "@components/En/imgUpload/imgUpload.vue";
export default {
  name: "add-certificate",
  data() {
    const that = this;
    const time = (rule, value, callback) => {
      if (that.formInline.time) {
        callback();
      } else {
        callback(new Error("Please select the time when the qualification certificate is issued"));
      }
    };
    return {
      commonType: 2,
      Introduction: [],
      editData: null,
      imgName: "",
      loading: false,
      // showModal: false,
      formInline: {
        name: "", // 名称
        number: "", // 证书编号
        authority: "", // 颁发机构
        time: "", // 颁发时间
        isShow: true, // 是否开启显示
        showIndex: 0, // 显示顺序
        activityType: "0"
      },
      ruleInline: {
        // 效验规则
        name: [
          { required: true, message: "Certificate name cannot be empty", trigger: "blur" },
          {
            type: "string",
            max: 200,
            message: "证书名称文字说明不能大于200字",
            trigger: "blur"
          }
        ],
        number: [
          { required: true, message: "Please enter the serial number", trigger: "blur" }
        ],
        authority: [
          { required: true, message: "Please enter the issuing authority", trigger: "blur" }
        ],
        time: [{ required: true, validator: time, trigger: "blur" }]
        // Introduction: [
        //   { required: true, message: "必填选项", trigger: "blur" },
        //   {
        //     type: "string",
        //     max: 2000,
        //     message: "证书描述文字说明不能大于2000字",
        //     trigger: "blur"
        //   }
        // ]
      },
      uploadList: [],
      defaultList: [],
      uploadList2: [],
      defaultList2: [],
      visible: false,
      limitNum: 10, // 图文显示的限制图片个数
      uploadChooseShowed: false, // 控制文件上传方式的显示和隐藏
      uploadChooseShowed2: false, // 控制文件上传方式的显示和隐藏
      certificateType: [], // 证书名称
    };
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition"
    }),
    query() {
      return this.$router.history.current.query;
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getCertificateById: "companyModule/getCertificateById",
      editCertificate: "companyModule/editCertificate",
      transformCustomData: "customComponentModule/transformCustomData",
      transformReqCustomData: "customComponentModule/transformReqCustomData",
      getCertificateTypeList: "companyModule/getCertificateTypeList"
    }),
    async init() {
      if (!this.query.id) return;
      this.editData = await this.getCertificateById(this.query.id);
      console.log(this.editData);
      let certificateType = await this.getCertificateTypeList();
      if (certificateType && certificateType.length > 0) {
        this.certificateType = certificateType;
      }
      this.setData();
    },
    async setData() {
      this.formInline.name = this.editData.name; // 名称
      let flag = false;
      this.certificateType.map(c => {
        if (c.name == this.editData.name) {
          flag = true;
        }
      });
      if (!flag) {
        this.certificateType.push({
          name: this.editData.name
        });
      }
      this.formInline.number = this.editData.number; // 证书编号
      this.formInline.authority = this.editData.authority || null; // 颁发机构
      this.formInline.isShow = this.editData.isShow || false;
      this.formInline.showIndex = this.editData.showIndex || 0;
      this.formInline.Introduction = this.editData.introduction || [];
      this.formInline.time = this.editData.issueDate
        ? new Date(this.editData.issueDate)
        : new Date(); // 颁发机构
      if (this.editData.image) {
        this.uploadList = [
          {
            name: this.editData.name,
            url: this.editData.image,
            status: "finished",
            percentage: 100
          }
        ];
      }
      if (
        this.editData.introduction &&
        this.editData.introduction.indexOf("[") !== -1
      ) {
        this.Introduction = await this.transformCustomData(
          JSON.parse(this.editData.introduction)
        );
      }
    },
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
      }
    },
    handleSuccess2(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList2 = this.$refs.upload2.fileList;
      }
    },
    handleFormatError(file) {
      this.$Message.warning(`Incorrect file format, Upload image in jpg/png format`);
    },
    handleMaxSize(file) {
      this.$Message.warning(`File size exceeds configured limit, Upload image size less than 2M`);
    },
    handleBeforeUpload() {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Message.warning(`Upload ${limitNum} image only`);
      }
      return check;
    },
    handleBeforeUpload2() {
      const check = this.uploadList2.length < this.limitNum;
      if (!check) {
        this.$Message.warning(`Upload ${this.limitNum} image only`);
      }
      console.log("this.uploadList2", this.uploadList2);
      return check;
    },
    handleRemoveByArr(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    handleRemoveByArr2(file) {
      const fileList = this.uploadList2;
      this.uploadList2.splice(fileList.indexOf(file), 1);
    },
    async handleSubmit(name,e) {
      let form = this.formInline;
      let imgList = this.transfromImgList(this.uploadList);
      let time = this.formInline.time
        ? moment(this.formInline.time).format("YYYY-MM-DD")
        : "";
      let valid = await this.validForm(name);
      if (!valid) return;
      if (!(this.uploadList && this.uploadList.length)) {
        this.$Message.error(`请上传证书图片`);
        return;
      }

      let Introduction = await this.transformReqCustomData(this.Introduction);
      if (!Introduction || Introduction === "[]") {
        this.$Message.error(`Please complete the details`);
        return;
      }
      let formData = {
        Id: this.editData.id,
        SetValues: {
          Name: form.name || "",
          Number: form.number || "",
          Authority: form.authority || "",
          IsShow: true,
          ShowIndex: form.showIndex || 0,
          Image: this.uploadList[0].url,
          StyleId: String(form.activityType),
          Introduction: Introduction
        }
      };
      this.loading = true;
      let bool = await this.editCertificate(formData);
      this.loading = false;
      if (bool.successed) {
        this.$Message.success("successful");
        if (e === 0) {
          this.$router.push("/exhibitionEn/index/certificate/allcertificate");
        }
        if (e === 1) {
          this.$router.push("/exhibitionEn/index/template");
        }
      } else {  
        this.$Message.error("fail,please try again");
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    // 查看上传图片
    handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    transfromImgList(arr) {
      let arr2 = [];
      arr.forEach(c => {
        arr2.push(c.url);
      });
      return arr2;
    },
    // 选择图片上传方式
    selectType() {
      this.uploadChooseShowed = true;
    },
    selectType2() {
      this.uploadChooseShowed2 = true;
    },
    // 拦截上传方法
    uploadLocal() {
      this.$refs.upload.handleClick();
    },
    uploadLocal2() {
      this.$refs.upload2.handleClick();
    },
    // 接收素材库上传的文件
    uploadMaterial(e) {
      for (let item of e) {
        if (this.uploadList.length >= 1) {
          this.$Message.warning(`Upload one image only图片`);
          return;
        } else {
          this.uploadList.push({
            status: "finished",
            url: item
          });
          this.uploadChooseShowed = false;
        }
      }
    },
    uploadMaterial2(e) {
      for (let item of e) {
        if (this.uploadList2.length >= 10) {
          this.$Message.warning(`Upload 10 image only张图片`);
          return;
        } else {
          this.uploadList2.push({
            status: "finished",
            url: item
          });
        }
      }
    },
    changModal($event) {
      this.Introduction = $event;
      console.log($event);
    },
    handleCreate (val) {
      this.certificateType.push({
        name: val
      });
    },
  },
  mounted() {
    if (this.$refs.upload) {
      this.uploadList = this.$refs.upload.fileList;
    }
    if (this.$refs.upload2) {
      this.uploadList2 = this.$refs.upload2.fileList;
    }
  },
  components: {
    imgUpload,
    uploadChoose,
    customComponentCommon
  }
};
</script>

<style lang="scss" scoped>
.my-item {
  min-width: 1200px;
}
.addcertificate {
  background: #fff;
  &-box {
    padding: 20px 85px 40px;
    max-width: 800px;
  }
}
.my-modal {
  &-content {
    padding-right: 20px;
  }
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
.preview {
  cursor: pointer;
}
</style>